"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCompetitionSettingsCommand = instanceOfCompetitionSettingsCommand;
exports.CompetitionSettingsCommandFromJSON = CompetitionSettingsCommandFromJSON;
exports.CompetitionSettingsCommandFromJSONTyped = CompetitionSettingsCommandFromJSONTyped;
exports.CompetitionSettingsCommandToJSON = CompetitionSettingsCommandToJSON;
exports.CompetitionSettingsCommandToJSONTyped = CompetitionSettingsCommandToJSONTyped;
var ChatProvider_1 = require("./ChatProvider");
var SignUpMode_1 = require("./SignUpMode");
var NetworkKind_1 = require("./NetworkKind");
/**
 * Check if a given object implements the CompetitionSettingsCommand interface.
 */
function instanceOfCompetitionSettingsCommand(value) {
    return true;
}
function CompetitionSettingsCommandFromJSON(json) {
    return CompetitionSettingsCommandFromJSONTyped(json, false);
}
function CompetitionSettingsCommandFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'teamSizeMin': json['teamSizeMin'] == null ? undefined : json['teamSizeMin'],
        'teamSizeMax': json['teamSizeMax'] == null ? undefined : json['teamSizeMax'],
        'signUpMode': json['signUpMode'] == null ? undefined : (0, SignUpMode_1.SignUpModeFromJSON)(json['signUpMode']),
        'representSameCommunity': json['representSameCommunity'] == null ? undefined : json['representSameCommunity'],
        'requiredNetwork': json['requiredNetwork'] == null ? undefined : (0, NetworkKind_1.NetworkKindFromJSON)(json['requiredNetwork']),
        'required2ndNetwork': json['required2ndNetwork'] == null ? undefined : (0, NetworkKind_1.NetworkKindFromJSON)(json['required2ndNetwork']),
        'requireNetworkUpfront': json['requireNetworkUpfront'] == null ? undefined : json['requireNetworkUpfront'],
        'requiredPermit': json['requiredPermit'] == null ? undefined : json['requiredPermit'],
        'requiredOrganization': json['requiredOrganization'] == null ? undefined : json['requiredOrganization'],
        'reportTimerMinutes': json['reportTimerMinutes'] == null ? undefined : json['reportTimerMinutes'],
        'channelCloseDelaySeconds': json['channelCloseDelaySeconds'] == null ? undefined : json['channelCloseDelaySeconds'],
        'discordIntegrationId': json['discordIntegrationId'] == null ? undefined : json['discordIntegrationId'],
        'supportingCause': json['supportingCause'] == null ? undefined : json['supportingCause'],
        'donationGoal': json['donationGoal'] == null ? undefined : json['donationGoal'],
        'participantInquiry': json['participantInquiry'] == null ? undefined : json['participantInquiry'],
        'hideRegistration': json['hideRegistration'] == null ? undefined : json['hideRegistration'],
        'matchTicker': json['matchTicker'] == null ? undefined : json['matchTicker'],
        'entryRepresentingOptional': json['entryRepresentingOptional'] == null ? undefined : json['entryRepresentingOptional'],
        'allowParentUsers': json['allowParentUsers'] == null ? undefined : json['allowParentUsers'],
        'allowChildUsers': json['allowChildUsers'] == null ? undefined : json['allowChildUsers'],
        'allowCommunityManagedUsers': json['allowCommunityManagedUsers'] == null ? undefined : json['allowCommunityManagedUsers'],
        'chatProvider': json['chatProvider'] == null ? undefined : (0, ChatProvider_1.ChatProviderFromJSON)(json['chatProvider']),
    };
}
function CompetitionSettingsCommandToJSON(json) {
    return CompetitionSettingsCommandToJSONTyped(json, false);
}
function CompetitionSettingsCommandToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'teamSizeMin': value['teamSizeMin'],
        'teamSizeMax': value['teamSizeMax'],
        'signUpMode': (0, SignUpMode_1.SignUpModeToJSON)(value['signUpMode']),
        'representSameCommunity': value['representSameCommunity'],
        'requiredNetwork': (0, NetworkKind_1.NetworkKindToJSON)(value['requiredNetwork']),
        'required2ndNetwork': (0, NetworkKind_1.NetworkKindToJSON)(value['required2ndNetwork']),
        'requireNetworkUpfront': value['requireNetworkUpfront'],
        'requiredPermit': value['requiredPermit'],
        'requiredOrganization': value['requiredOrganization'],
        'reportTimerMinutes': value['reportTimerMinutes'],
        'channelCloseDelaySeconds': value['channelCloseDelaySeconds'],
        'discordIntegrationId': value['discordIntegrationId'],
        'supportingCause': value['supportingCause'],
        'donationGoal': value['donationGoal'],
        'participantInquiry': value['participantInquiry'],
        'hideRegistration': value['hideRegistration'],
        'matchTicker': value['matchTicker'],
        'entryRepresentingOptional': value['entryRepresentingOptional'],
        'allowParentUsers': value['allowParentUsers'],
        'allowChildUsers': value['allowChildUsers'],
        'allowCommunityManagedUsers': value['allowCommunityManagedUsers'],
        'chatProvider': (0, ChatProvider_1.ChatProviderToJSON)(value['chatProvider']),
    };
}
